/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';
import {Component} from 'preact';
import PropTypes from 'prop-types';
/*:: import type {SocialNetwork} from '../SocialNetworks.js'; */
import * as socialNetworks from '../SocialNetworks.js';
import {Twitter, Facebook, Email, Qrcode} from './Icons.js';

const socialIcons /*: {[$Keys<typeof socialNetworks>]: *} */ = {
  twitter : Twitter,
  facebook: Facebook,
  email   : Email,
  qrcode  : Qrcode,
};

/*:: type Props = {
  +network: $Keys<typeof socialNetworks>,
  +text: string,
  +url: string,
  +details?: string,
}; */

export class SocialButton extends Component /*:: <Props> */ {
  static propTypes = {
    network: PropTypes.oneOf(Object.keys(socialIcons)).isRequired,
    text   : PropTypes.string.isRequired,
    url    : PropTypes.string.isRequired,
    details: PropTypes.string,
  };

  baseAnchor /*: ?HTMLAnchorElement */ = null;

  refBase /*: (base: ?HTMLAnchorElement) => void */ = (base) => {
    this.baseAnchor = base;
  };

  handleClick /*: (event: MouseEvent) => void */ = (event) => {
    const base = this.baseAnchor;
    const network = this.props.network;
    // eslint-disable-next-line import/namespace
    const socialNetwork /*: SocialNetwork */ = (socialNetworks[network] /*: $FlowIssue */);
    const windowProps = socialNetwork.window;

    if (!windowProps || !base) {
      return;
    }

    event.preventDefault();

    // Calculate the position of the popup so it’s centered on the screen.
    const width = windowProps.width;
    const height = windowProps.height;
    const left = screen.width / 2 - width / 2;
    const top = screen.height / 2 - height / 2;

    window.open(
      base.href,
      windowProps.name,
      `${windowProps.features},width=${width},height=${height},top=${top},left=${left},noopener=1`
    );
  };

  render() /*: React$Node */ {
    const {network, text, url, details} = this.props;
    // eslint-disable-next-line import/namespace
    const socialNetwork /*: SocialNetwork */ = (socialNetworks[network] /*: $FlowIssue */);
    const isEmail = socialNetwork.name.toLowerCase() === 'e-mail';
    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(
      isEmail && details ? `${url}\n\n${details}` : url
    );
    const via = isEmail ? 'by' : 'on';
    const shareText = `Share ${via} ${socialNetwork.name}`;
    const SocialIcon = socialIcons[network];

    return html`
      <a
        ref=${this.refBase}
        href=${socialNetwork.url(encodedText, encodedUrl)}
        target=${socialNetwork.window && socialNetwork.window.name}
        rel="noopener"
        title=${shareText}
        aria-label=${shareText}
        data-network=${network}
        onClick=${this.handleClick}
      >
        <${SocialIcon} color="#FFF" />
      </a>
    `;
  }
}
